// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3216":"0f24a92d","5277":"432bc998","5382":"3db296d1","9181":"70b7f3a1"}[chunkId] + ".chunk.css";
};